<template>
	<Teleport to="body">
		<Transition name="modal">
			<div
				v-if="showModal"
				class="modal-wrapper"
				@click.self="closeModal"
				aria-modal="true"
				role="dialog"
				tabindex="-1"
			>
				<div :class="['modal-inner', showModal && 'show', hide && 'hide']">
					<div class="modal-header">
						<h4 v-if="title" class="modal-title">
							{{ title }}
						</h4>
						<button v-if="!prevent" type="button" aria-label="Close" @click="closeModal">
							<span aria-hidden="true">
								<svg-vue width="14" height="14" icon="close-modal" />
							</span>
						</button>
					</div>
					<div class="modal-body">
						<slot name="content" />
					</div>
				</div>
			</div>
		</Transition>
	</Teleport>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
			default: null,
		},
		show: {
			type: Boolean,
			default: false,
		},
		prevent: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['opened', 'closed'],
	data() {
		return {
			showModal: this.show,
			isNested: false,
			hide: false,
		}
	},
	mounted() {
		document.addEventListener('keydown', this.keydownListener)
		if (this.showModal) {
			this.lockBody()
		}
	},
	unmounted() {
		document.removeEventListener('keydown', this.keydownListener)
	},
	methods: {
		keydownListener(e) {
			if (e.key === 'Escape' && !this.isNested) {
				e.preventDefault()
				this.closeModal()
			}
		},
		lockBody() {
			// temp removal until I figure out the body lock scroll bug
			// document.querySelector('body').classList.add('lock-body')
		},
		unLockBody() {
			// temp removal until I figure out the body lock scroll bug
			// document.querySelector('body').classList.remove('lock-body')
		},
		enableIsNested() {
			this.isNested = true
		},
		disableIsNested() {
			this.isNested = false
		},
		dynamicHide() {
			this.hide = true
		},
		dynamicShow() {
			this.hide = false
		},
		openModal() {
			this.showModal = true
			this.lockBody()
			this.$emit('opened')
		},
		closeModal() {
			if (!this.prevent) {
				this.showModal = false
				this.unLockBody()
				this.$emit('closed')
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.modal-wrapper {
	outline: none;
	z-index: 9999;
	position: fixed;
	inset: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.2);
	display: grid;
	place-items: center;
}
.modal-inner {
	overflow: hidden;
	&.hide {
		opacity: 0;
		visibility: hidden;
	}
	position: relative;
	border-radius: 0;
	border-color: #b6b6b6;
	background-color: #ffffff;
	max-width: 375px;
	width: 100%;
	display: flex;
	flex-direction: column;
	.modal-header {
		position: relative;
		padding: 16px;
		border-bottom: none;
		h4 {
			font-style: normal;
			font-weight: 500;
			font-size: 20px;
			line-height: 30px;
			color: #101828;
		}
		button {
			position: absolute;
			right: 16px;
			top: 16px;
		}
	}
	.modal-body {
		padding: 0 16px;
	}
	.modal-enter-active,
	.modal-leave-active {
		transition: 0.25s ease all;
	}
	@media (max-width: 430px) {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		margin: 0;
		max-height: 100%;
		max-width: 100%;
		.modal-enter-to,
		.modal-leave {
			overflow: hidden;
		}
		.modal-enter,
		.modal-leave-to {
			overflow: hidden;
			max-height: 0;
		}
		.modal-enter-active {
			transition-duration: 0.4s;
			transition-timing-function: ease-in;
		}
		.modal-leave-active {
			transition-duration: 0.8s;
			transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
		}
	}
}
</style>
